import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pricePipe', standalone: true })
export class PricePipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return '0';

    return value.toLocaleString('ko-KR');
  }
}
